import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	MotifModal,
	MotifModalHeader,
	MotifModalBody,
	MotifModalFooter,
	MotifButton,
} from "@ey-xd/motif-react";
import { useLazyDeleteClassQuery } from "@/services/class/classReducer";
import { CANCEL_BUTTON_VARIANT, CONFIRM_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";
interface DeleteClassProps {
	show: boolean;
	setShow: (value: boolean) => void;
	id: string | undefined;
	setDeleteErrorMessage: (message: string) => void;
	refetch: () => void;
	entityName:any
}

const DeleteClass = ({
	show,
	setShow,
	id,
	setDeleteErrorMessage,
	refetch,
	entityName
}: DeleteClassProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [deleteClass] = useLazyDeleteClassQuery();

	const handleCancel = () => {
		setShow(false);
		setDeleteErrorMessage("");
	};

	const handleDelete = () => {
		setIsLoading(true);
		setDeleteErrorMessage("");
		deleteClass(id).then((response: any) => {
			if (response.data) {
				refetch();
			} else {
				const errorMessage = response.error?.data?.message;
				setDeleteErrorMessage(errorMessage);
			}
			setIsLoading(false);
			setShow(false);
		});
	};
	return (
    <MotifModal
      onClose={handleCancel}
      show={show}
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <div className="confirmationModalWrapper creditor_disabling_model">
        <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>

        <MotifModalBody style={{ paddingTop: "0px" }}>
          {useTrans(
            t,
            t("pages.configuration.scheme.class.deleteClassMessage", {
              className: entityName,
            }),
            "className"
          )}
        </MotifModalBody>

        <MotifModalFooter>
          <MotifButton
            onClick={handleCancel}
            type={"button"}
            variant={CANCEL_BUTTON_VARIANT}
          >
            {t("pages.configuration.scheme.class.cancel")}
          </MotifButton>
          <MotifButton
            onClick={handleDelete}
            type={isLoading ? "loader" : "submit"}
            variant={CONFIRM_BUTTON_VARIANT}
            disabled={isLoading}
          >
            {t("pages.configuration.scheme.class.confirm")}
          </MotifButton>
        </MotifModalFooter>
      </div>
    </MotifModal>
  );
};
export default DeleteClass;
